import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import {
  Warning,
  Delete,
} from '@mui/icons-material';

const FolderDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  folder,
  subfolderCount = 0,
  isDeleting = false,
}) => {
  const hasSubfolders = subfolderCount > 0;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Warning color="error" />
        Delete Customer Data Folder
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {hasSubfolders ? (
            <>
              Delete <strong>"{folder?.name}"</strong> and its {subfolderCount}{' '}
              {subfolderCount === 1 ? 'subfolder' : 'subfolders'}? All files and
              knowledge-base data inside them will be permanently removed.
            </>
          ) : (
            <>
              Are you sure you want to delete the customer data folder{' '}
              <strong>"{folder?.name}"</strong>?
            </>
          )}
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> This action will permanently delete the D3 folder
            {hasSubfolders ? ', all nested subfolders,' : ''} and all files within this
            knowledge base. This action cannot be undone.
          </Typography>
        </Alert>
        <Typography variant="body2" color="text.secondary">
          All uploaded documents, processed chunks, and vector embeddings associated with
          {hasSubfolders ? ' these folders' : ' this D3 folder'} will be permanently removed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} /> : <Delete />}
        >
          {isDeleting ? 'Deleting...' : 'Delete D3 Folder'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FolderDeleteDialog;
